/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

/**
 * 추가 모집 종료 방식 (수동 추가 모집 전용, null=해당 없음)
 */
export type AdditionalRecruitEndType = typeof AdditionalRecruitEndType[keyof typeof AdditionalRecruitEndType];


export const AdditionalRecruitEndType = {
  AUTO_CLOSE: 'AUTO_CLOSE',
  PERIOD_CLOSE: 'PERIOD_CLOSE',
} as const;
